import * as leaflet from "leaflet";
import { TileCoordinates } from "../../lib/runescape/coordinates";
import { direction, MovementAbilities, PlayerPosition } from "../../lib/runescape/movement";
import { Vector2 } from "../../lib/math";
import { GameLayer } from "../../lib/gamemap/GameLayer";
import { Observable, observe } from "../../lib/reactive";
import { util } from "../../lib/util/util";
var possibility_raster = MovementAbilities.possibility_raster;
var observe_combined = Observable.observe_combined;
var eqWithNull = util.eqWithNull;
import { HostedMapCollisionData } from "../../lib/runescape/CollisionData";
import { LeafletPolygonConstructors } from "../../lib/gamemap/LeafletPolygonConstructors";
var tileHalfPolygons = LeafletPolygonConstructors.tileHalfPolygons;
var tilePolygon = LeafletPolygonConstructors.tilePolygon;
export class AbilityLens extends leaflet.FeatureGroup {
    constructor(tile, assumptions, surge_escape_for = []) {
        super();
        this.tile = tile;
        this.assumptions = assumptions;
        this.surge_escape_for = surge_escape_for;
        this.render();
    }
    async render() {
        const raster = await possibility_raster(HostedMapCollisionData.get(), this.assumptions, this.tile, this.surge_escape_for);
        function style(color) {
            return {
                fillOpacity: 0.2,
                stroke: false,
                fillColor: color,
            };
        }
        const polygons = [];
        for (let dx = 0; dx < raster.data.size.x; dx++) {
            for (let dy = 0; dy < raster.data.size.y; dy++) {
                const tile = TileCoordinates.move(raster.data.origin, { x: dx, y: dy });
                const works = raster.data.query(tile);
                if (works) {
                    if (this.surge_escape_for.length > 0) {
                        const surge = raster.targets.some(t => Vector2.eq(tile, t.surge));
                        const escape = raster.targets.some(t => Vector2.eq(tile, t.escape));
                        if (surge && escape) {
                            const [s, e] = tileHalfPolygons(tile, [style("#426896"), style("#234709")]);
                            polygons.push(s, e);
                        }
                        else if (surge) {
                            polygons.push(tilePolygon(tile, style("#426896")));
                        }
                        else if (escape) {
                            polygons.push(tilePolygon(tile, style("#234709")));
                        }
                        else {
                            polygons.push(tilePolygon(tile, style("#e2c40c")));
                        }
                    }
                    else {
                        polygons.push(tilePolygon(tile, style("#e2c40c")));
                    }
                }
                else {
                    polygons.push(tilePolygon(tile, style("red")));
                }
            }
        }
        polygons.forEach(p => p.addTo(this));
    }
}
export class StatefulAbilityLens extends GameLayer {
    constructor(builder) {
        super();
        this.builder = builder;
        this.active_lens = null;
        this.enabled1 = observe(true);
        this.enabled2 = observe(true);
        this.static = observe(true);
        this.render_for_state = observe(null).equality((eqWithNull(PlayerPosition.eq)));
        builder.cursor_state.subscribe(s => {
            if (this.static.value())
                this.render_for_state.set(s?.state?.position);
        }, true);
        this.static.subscribe(v => {
            if (v)
                this.render_for_state.set(builder.cursor_state.value()?.state?.position);
        });
        observe_combined({
            enabled1: this.enabled1,
            enabled2: this.enabled2,
            state: this.render_for_state
        }).subscribe(({ enabled1, enabled2, state }) => {
            const render_at_all = enabled1 && enabled2 && state?.tile;
            this.render(render_at_all ? state : undefined);
        }, true);
    }
    render(state) {
        if (this.active_lens) {
            this.active_lens.remove();
            this.active_lens = null;
        }
        if (!state?.tile)
            return;
        this.active_lens = new AbilityLens(state.tile, this.builder.assumptions(), state.direction ?
            [state.direction] : direction.all).addTo(this);
    }
    eventHover(event) {
        event.onPre(() => {
            if (!this.static.value()) {
                this.render_for_state.set({
                    tile: event.tile(),
                    direction: 0
                });
            }
        });
    }
}
